export { IconTextPair } from './IconTextPair';
